// import React, { useState, useEffect } from "react";
// import { useLocation, useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   disburseLoan,
//   resetDisbursementState,
// } from "../redux/slices/loanDisbursementSlice";
// import "../css/LoanDisbursement.css";

// const LoanDisbursementPage = () => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const loan = location.state?.selectedLoan;
//   const dispatch = useDispatch();

//   const { loading, success, error } = useSelector(
//     (state) => state.loanDisbursement
//   );

//   // ✅ Safe initial state
//   const [formData, setFormData] = useState({
//     disbursalDate: "",
//     firstEmiDate: "",
//     loanDisbursalMode: "",
//     chargeCollectionMode: "",
//     bankReference: "",
//     disbursalRemark: "",
//   });

//   // ✅ Format as "YYYY-MM-DD 00:00:00"
//   const formatDateTime = (date) => {
//     if (!date) return null;
//     return `${date} 00:00:00`;
//   };

//   // ✅ Pre-fill if available
//   useEffect(() => {
//     if (loan) {
//       setFormData((prev) => ({
//         ...prev,
//         bankReference: loan.bankReference || "",
//         disbursalRemark: loan.remarks || "",
//       }));
//     }
//   }, [loan]);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   // ✅ FIX: include loan.id in API call
//   const handleDisburse = () => {
//     if (!loan) return alert("No loan selected!");

//     const payload = {
//       loanId: loan.id, // IMPORTANT 🔥
//       disbursalDate: formatDateTime(formData.disbursalDate),
//       firstEmiDate: formatDateTime(formData.firstEmiDate),
//       loanDisbursalMode: formData.loanDisbursalMode,
//       chargeCollectionMode: formData.chargeCollectionMode,
//       bankReference: formData.bankReference,
//       disbursalRemark: formData.disbursalRemark,
//     };

//     dispatch(disburseLoan(payload));
//   };

//   // ✅ Navigate to EMI page
//   const handleViewEmi = () => {
//     if (!loan) return alert("No loan selected!");
//     <button onClick={() => navigate(`/ViewEmiLoanData/${loan.id}`)}>
//       View EMI
//     </button>;
//   };

//   // ✅ Reset after 3s
//   useEffect(() => {
//     if (success || error) {
//       const timer = setTimeout(() => {
//         dispatch(resetDisbursementState());
//       }, 3000);
//       return () => clearTimeout(timer);
//     }
//   }, [success, error, dispatch]);

//   if (!loan)
//     return (
//       <div className="Techvision-loan-disburse-container">No loan selected</div>
//     );

//   return (
//     <div className="Techvision-loan-disburse-container">
//       <h2 className="Techvision-loan-disburse-header">Loan Disbursement</h2>

//       {/* Loan Details */}
//       <div className="Techvision-loan-disburse-card">
//         <table className="Techvision-loan-disburse-details-table">
//           <tbody>
//             <tr>
//               <td>Loan ID</td>
//               <td>{loan.id}</td>
//             </tr>
//             <tr>
//               <td>Loan Account NO.</td>
//               <td>{loan.loanAccountNumber}</td>
//             </tr>
//             <tr>
//               <td>Borrower Name</td>
//               <td>{loan.userName}</td>
//             </tr>
//             <tr>
//               <td>Loan Amount</td>
//               <td>₹{loan.loanAmount}</td>
//             </tr>
//             <tr>
//               <td>Interest Amount</td>
//               <td>₹{loan.loanInterest}</td>
//             </tr>
//             <tr>
//               <td>Loan Tenure</td>
//               <td>{loan.loanTenure} M</td>
//             </tr>
//             <tr>
//               <td>Purpose</td>
//               <td>{loan.loanPurpose}</td>
//             </tr>
//             <tr>
//               <td>Applied Date</td>
//               <td>{new Date(loan.appliedDate).toLocaleDateString()}</td>
//             </tr>
//           </tbody>
//         </table>
//       </div>

//       {/* Form */}
//       <div className="Techvision-loan-disburse-card">
//         <div className="Techvision-loan-disburse-form-grid">
//           <div className="Techvision-loan-disburse-form-group">
//             <label>Disbursal Date</label>
//             <input
//               type="date"
//               name="disbursalDate"
//               value={formData.disbursalDate || ""}
//               onChange={handleChange}
//             />
//           </div>

//           <div className="Techvision-loan-disburse-form-group">
//             <label>First EMI Date</label>
//             <input
//               type="date"
//               name="firstEmiDate"
//               value={formData.firstEmiDate || ""}
//               onChange={handleChange}
//             />
//           </div>

//           <div className="Techvision-loan-disburse-form-group">
//             <label>Disbursal Mode</label>
//             <select
//               name="loanDisbursalMode"
//               value={formData.loanDisbursalMode || ""}
//               onChange={handleChange}
//             >
//               <option value="">Select mode</option>
//               <option value="Bank">Bank</option>
//               <option value="Cash">Cash</option>
//               <option value="Cheque">Cheque</option>
//             </select>
//           </div>

//           <div className="Techvision-loan-disburse-form-group">
//             <label>Charge Collection Mode</label>
//             <select
//               name="chargeCollectionMode"
//               value={formData.chargeCollectionMode || ""}
//               onChange={handleChange}
//             >
//               <option value="">Select mode</option>
//               <option value="Cash">Cash</option>
//               <option value="Online">Online</option>
//               <option value="Bank">Bank</option>
//             </select>
//           </div>

//           <div className="Techvision-loan-disburse-form-group">
//             <label>Transfer Reference</label>
//             <select
//               name="bankReference"
//               value={formData.bankReference || ""}
//               onChange={handleChange}
//             >
//               <option value="">Select transfer mode</option>
//               <option value="NEFT">NEFT</option>
//               <option value="RTGS">RTGS</option>
//               <option value="IMPS">IMPS</option>
//               <option value="UPI">UPI</option>
//               <option value="Cheque">Cheque</option>
//             </select>
//           </div>

//           <div className="Techvision-loan-disburse-form-group">
//             <label>Remarks</label>
//             <input
//               type="text"
//               name="disbursalRemark"
//               value={formData.disbursalRemark || ""}
//               onChange={handleChange}
//               placeholder="Any remarks"
//             />
//           </div>
//         </div>
//       </div>

//       {/* Actions */}
//       <div className="Techvision-loan-disburse-actions">
//         <button
//           className="Techvision-loan-disburse-btn-disburse"
//           onClick={handleDisburse}
//           disabled={loading}
//         >
//           {loading ? "Processing..." : "Disburse Loan"}
//         </button>
//         <button
//           className="Techvision-loan-disburse-btn-view-emi"
//           onClick={() => navigate(`/ViewEmiLoanData/${loan.id}`)}
//         >
//           View EMI
//         </button>
//       </div>

//       {/* Status */}
//       {success && (
//         <div className="success-message">
//           ✅ EMI Generated Successfully! Loan ID: {loan.id}
//         </div>
//       )}
//       {error && (
//         <div className="error-message">
//           ❌{" "}
//           {typeof error === "string"
//             ? error
//             : error?.message || "Something went wrong"}
//         </div>
//       )}
//     </div>
//   );
// };

// export default LoanDisbursementPage;



import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  disburseLoan,
  resetDisbursementState,
} from "../redux/slices/loanDisbursementSlice";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../css/LoanDisbursement.css";
import axios from "axios";

const LoanDisbursementPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const loan = location.state?.selectedLoan;
  const dispatch = useDispatch();

  const { loading, success, error } = useSelector(
    (state) => state.loanDisbursement
  );

  const [formData, setFormData] = useState({
    disbursalDate: "",
    firstEmiDate: "",
    loanDisbursalMode: "",
    chargeCollectionMode: "",
    bankReference: "",
    disbursalRemark: "",
  });

  const [errors, setErrors] = useState({});
  const [fees, setFees] = useState([]);

  // Format date to "YYYY-MM-DD 00:00:00"
  const formatDateTime = (date) => {
    if (!date) return null;
    return `${date} 00:00:00`;
  };

  // Fetch all fees from API & filter by adminuserId + applicableOn: "Disbursal"
  useEffect(() => {
    const adminuserId = localStorage.getItem("adminuserId");

    const fetchFees = async () => {
      try {
        const res = await fetch(`https://payyug.in/api/all-fee-master?superadminId=${adminuserId}&applicableOn=Disbursal&service=${loan.schemeId}`);
        const data = await res.json();
        if (data.success) {
          const filteredFees = data.data;
          // .filter(
          //   (fee) =>
          //     String(fee.superadminId) === String(adminuserId) &&
          //     fee.applicableOn === "Disbursal"
          // );
          console.log("fees",filteredFees)
          setFees(filteredFees);
        }
      } catch (err) {
        console.error("Error fetching fees:", err);
      }
    };
    fetchFees();
  }, []);

  useEffect(() => {
    if (loan) {
      setFormData((prev) => ({
        ...prev,
        bankReference: loan.bankReference || "",
        disbursalRemark: loan.remarks || "",
      }));
    }
  }, [loan]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (value.trim() !== "") {
      setErrors((prev) => ({ ...prev, [name]: false }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.disbursalDate) newErrors.disbursalDate = true;
    if (!formData.firstEmiDate) newErrors.firstEmiDate = true;
    if (!formData.loanDisbursalMode) newErrors.loanDisbursalMode = true;
    if (!formData.chargeCollectionMode) newErrors.chargeCollectionMode = true;
    if (!formData.bankReference) newErrors.bankReference = true;
    if (!formData.disbursalRemark.trim()) newErrors.disbursalRemark = true;

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleDisburse = async () => {
  if (!loan) {
    toast.error("No loan selected!");
    return;
  }

  if (!validateForm()) {
    toast.error("Please fill all mandatory fields!");
    return;
  }

  try {
    // FIXED LOAN FLOW
    if (loan.loanType?.toLowerCase().includes("fixed")) {
      const payload = {
        disbursalDate: formData.disbursalDate,
        firstEmiDate: formData.firstEmiDate,
        disbursalRemark: formData.disbursalRemark,
        loanDisbursalMode: formData.loanDisbursalMode,
        chargeCollectionMode: formData.chargeCollectionMode,
      };

      const response = await axios.post(
        `https://payyug.in/api/loan/fixed-emi/disbursed/${loan.id}`,
        payload
      );

      if (response?.data) {
        toast.success(
          response.data.message || "Fixed Loan Disbursed Successfully!"
        );

        setTimeout(() => {
          navigate(-1);
        }, 1500);
      }

      return;
    }

    // EXISTING FLOW FOR ALL OTHER LOAN TYPES
    const payload = {
      loanId: loan.id,
      disbursalDate: formatDateTime(formData.disbursalDate),
      firstEmiDate: formatDateTime(formData.firstEmiDate),
      loanDisbursalMode: formData.loanDisbursalMode,
      chargeCollectionMode: formData.chargeCollectionMode,
      bankReference: formData.bankReference,
      disbursalRemark: formData.disbursalRemark,
    };

    dispatch(disburseLoan(payload));
  } catch (error) {
    console.error("Disbursement Error:", error);

    toast.error(
      error?.response?.data?.message ||
        error?.message ||
        "Failed to disburse loan"
    );
  }
};

  useEffect(() => {
    if (success || error) {
      const timer = setTimeout(() => {
        dispatch(resetDisbursementState());
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [success, error, dispatch]);

  if (!loan)
    return (
      <div className="Techvision-loan-disburse-container">No loan selected</div>
    );

  const inputClass = (field) =>
    errors[field]
      ? "Techvision-loan-disburse-input error"
      : "Techvision-loan-disburse-input";

  // --- Calculate charges with GST and total ---
  const calculateCharges = () => {
    let total = 0;
    const feeDetails = fees.map((fee) => {
      let baseValue = 0;

      if (fee.type?.toLowerCase() === "percentage") {
        baseValue = (loan.loanAmount * fee.value) / 100;
      } else {
        baseValue = Number(fee.value);
      }

      let gst = 0;
      if (fee.gstIncluded) {
        gst = (baseValue * 18) / 100;
      }

      const totalFee = baseValue + gst;
      total += totalFee;

      return {
        ...fee,
        baseValue,
        gst,
        totalFee,
      };
    });

    return { feeDetails, total };
  };

  const { feeDetails, total } = calculateCharges();
  const disbursalAmount = loan.loanAmount - total;

  return (
    <div className="Techvision-loan-disburse-container">
      <ToastContainer position="top-right" autoClose={3000} />

      <h2 className="Techvision-loan-disburse-header">Loan Disbursement</h2>

      {/* Loan Details */}
      <div className="Techvision-loan-disburse-card">
        <table className="Techvision-loan-disburse-details-table">
          <tbody>
            <tr>
              <td>Loan ID</td>
              <td>{loan.id}</td>
            </tr>
            <tr>
              <td>Loan Account NO.</td>
              <td>{loan.loanAccountNumber}</td>
            </tr>
            <tr>
              <td>Borrower Name</td>
              <td>{loan.userName}</td>
            </tr>
            <tr>
              <td>Loan Amount</td>
              <td>₹{loan.loanAmount}</td>
            </tr>
            <tr>
              <td>Interest Amount</td>
              <td>₹{loan.loanInterest}</td>
            </tr>
            <tr>
              <td>Loan Tenure</td>
              <td>{loan.loanTenure} </td>
            </tr>
            <tr>
              <td>Purpose</td>
              <td>{loan.loanPurpose}</td>
            </tr>
            <tr>
              <td>Applied Date</td>
              <td>{new Date(loan.loanAppliedDate).toLocaleDateString()}</td>
            </tr>
            <tr>
              <td>Loan Type</td>
              <td>{loan.loanType || "-"}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Filtered Fees (applicableOn: Disbursal) */}
      {feeDetails.length > 0 && (
        <div className="Techvision-loan-disburse-card">
          <h3>Disbursal Charges</h3>
          <table className="Techvision-loan-disburse-details-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Type</th>
                <th>Base Value</th>
                <th>GST (18%)</th>
                <th>Total Fee</th>
              </tr>
            </thead>
            <tbody>
              {feeDetails.map((fee) => (
                <tr key={fee.id}>
                  <td>{fee.name}</td>
                  <td>{fee.type}</td>
                  <td>
                    {fee.type?.toLowerCase() === "percentage"
                      ? `${fee.value}% = ₹${fee.baseValue.toFixed(2)}`
                      : `₹${fee.baseValue.toFixed(2)}`}
                  </td>
                  <td>{fee.gst > 0 ? `₹${fee.gst.toFixed(2)}` : "N/A"}</td>
                  <td>₹{fee.totalFee.toFixed(2)}</td>
                </tr>
              ))}
              <tr>
                <td colSpan="4" style={{ textAlign: "right", fontWeight: "bold" }}>
                  Total Charges
                </td>
                <td style={{ fontWeight: "bold" }}>₹{total.toFixed(2)}</td>
              </tr>
              <tr>
                <td colSpan="4" style={{ textAlign: "right", fontWeight: "bold" }}>
                  Disbursal Amount
                </td>
                <td style={{ fontWeight: "bold", color: "orange" }}>
                  ₹{disbursalAmount.toFixed(2)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}

      {/* Disbursement Form */}
      <div className="Techvision-loan-disburse-card">
        <div className="Techvision-loan-disburse-form-grid">
          <div className="Techvision-loan-disburse-form-group">
            <label>
              Disbursal Date <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="date"
              name="disbursalDate"
              value={formData.disbursalDate}
              onChange={handleChange}
              className={inputClass("disbursalDate")}
            />
          </div>

          <div className="Techvision-loan-disburse-form-group">
            <label>
              First EMI Date <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="date"
              name="firstEmiDate"
              value={formData.firstEmiDate}
              onChange={handleChange}
              className={inputClass("firstEmiDate")}
            />
          </div>

          <div className="Techvision-loan-disburse-form-group">
            <label>
              Disbursal Mode <span style={{ color: "red" }}>*</span>
            </label>
            <select
              name="loanDisbursalMode"
              value={formData.loanDisbursalMode}
              onChange={handleChange}
              className={inputClass("loanDisbursalMode")}
            >
              <option value="">Select mode</option>
              <option value="Bank">Bank</option>
              <option value="Cash">Cash</option>
              <option value="Cheque">Cheque</option>
            </select>
          </div>

          <div className="Techvision-loan-disburse-form-group">
            <label>
              Charge Collection Mode <span style={{ color: "red" }}>*</span>
            </label>
            <select
              name="chargeCollectionMode"
              value={formData.chargeCollectionMode}
              onChange={handleChange}
              className={inputClass("chargeCollectionMode")}
            >
              <option value="">Select mode</option>
              <option value="Cash">Cash</option>
              <option value="Online">Online</option>
              <option value="Bank">Bank</option>
            </select>
          </div>

          <div className="Techvision-loan-disburse-form-group">
            <label>
              Transfer Reference <span style={{ color: "red" }}>*</span>
            </label>
            <select
              name="bankReference"
              value={formData.bankReference}
              onChange={handleChange}
              className={inputClass("bankReference")}
            >
              <option value="">Select transfer mode</option>
              <option value="NEFT">NEFT</option>
              <option value="RTGS">RTGS</option>
              <option value="IMPS">IMPS</option>
              <option value="UPI">UPI</option>
              <option value="Cash">Cash</option>
              <option value="Cheque">Cheque</option>

            </select>
          </div>

          <div className="Techvision-loan-disburse-form-group">
            <label>
              Remarks <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              name="disbursalRemark"
              value={formData.disbursalRemark}
              onChange={handleChange}
              placeholder="Any remarks"
              className={inputClass("disbursalRemark")}
            />
          </div>
        </div>
      </div>

      {/* Actions */}
      <div className="Techvision-loan-disburse-actions">
        <button
          className="Techvision-loan-disburse-btn-disburse"
          onClick={handleDisburse}
          disabled={loading}
        >
          {loading ? "Processing..." : "Disburse Loan"}
        </button>
        <button
          className="Techvision-loan-disburse-btn-view-emi"
          onClick={() => navigate(`/ViewEmiLoanData/${loan.id}`,{state:loan})}
        >
          View EMI
        </button>
      </div>

      {/* Status Messages */}
      {success && (
        <div className="success-message">
          ✅ EMI Generated Successfully! Loan ID: {loan.id}
        </div>
      )}
      {error && (
        <div className="error-message">
          ❌{" "}
          {typeof error === "string"
            ? error
            : error?.message || "Something went wrong"}
        </div>
      )}
    </div>
  );
};

export default LoanDisbursementPage;